export enum SsoStatus {
  CONTINUE = 'CONTINUE', // Continue with the regular scheduled program flow
  INVALID = 'INVALID', // The SSO session is invalid and removed
  REDIRECT = 'REDIRECT', // The SSO session is valid and we can redirect
}
